import React from "react";
import { formatMessage } from "lib/globalize-util";
import { Label, TagPicker } from "@nuorder/components";

// This component should be used only when selectedItems are fetching. For that reason, the component is called `placeholder`
export const AssortmentPickerPlaceholder: React.FunctionComponent = () => {
    return (
        <>
            <Label required>{formatMessage("Choose assortments:")}</Label>
            <TagPicker onResolveSuggestions={() => null} loadingText={formatMessage("Loading...")} isLoading={true} />
        </>
    );
};
